import styled from '@emotion/styled'

const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export {
  FileUploadContainer
}